import { useQuery } from '@pinia/colada';
import { computed } from 'vue';

import teamService from '../services/team.service';

export const companyTeamQueryKey = 'company-team';

export function useCompanyTeamQuery() {
  const query = useQuery({
    key: () => [companyTeamQueryKey],
    query: () => teamService.getTeam(),
  });

  return {
    ...query,
    members: computed(() => query.data.value?.members ?? []),
    pendingInvites: computed(() => query.data.value?.pendingInvites ?? []),
  };
}
